import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { alpha, Box, ButtonBase, styled, Typography } from "@mui/material";

import { EXPIRING_SOON_DAYS } from "@helpers/constants";

type Props = {
  count: number;
  onShowExpiring: () => void;
  isFilterActive: boolean;
};

const BannerRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(1.25, 2),
  marginBottom: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.warning.main, 0.12),
  color: theme.palette.warning.dark,
}));

const CountButton = styled(ButtonBase)({
  color: "inherit",
  fontWeight: 600,
  fontSize: "inherit",
  textDecoration: "underline",
  verticalAlign: "baseline",
});

const ExpiringBanner = ({ count, onShowExpiring, isFilterActive }: Props) => {
  if (count === 0) return null;

  const noun = count === 1 ? "permission" : "permissions";
  const verb = count === 1 ? "expires" : "expire";

  return (
    <BannerRoot role="status">
      <AccessTimeIcon fontSize="small" />
      <Typography variant="body2" component="span">
        {isFilterActive ? (
          <>
            {count} {noun}
          </>
        ) : (
          <CountButton onClick={onShowExpiring}>
            {count} {noun}
          </CountButton>
        )}{" "}
        {verb} in the next {EXPIRING_SOON_DAYS} days.
      </Typography>
    </BannerRoot>
  );
};

export default ExpiringBanner;
